import { render, staticRenderFns } from "./BulkUpdatePurchaseOrderItemsDialog.vue?vue&type=template&id=ef0b4b8e&scoped=true"
import script from "./BulkUpdatePurchaseOrderItemsDialog.ts?vue&type=script&lang=ts&external"
export * from "./BulkUpdatePurchaseOrderItemsDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./BulkUpdatePurchaseOrderItemsDialog.scss?vue&type=style&index=0&id=ef0b4b8e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0b4b8e",
  null
  
)

export default component.exports